export const CAREER_LEVELS = [
  'CXO',
  'Director',
  'Manager',
  'Owner',
  'Partner',
  'Senior',
  'Training',
  'Unpaid',
  'VP',
]

export const RECENCY_TRIGGERS = [
  'Recent Purchase Date',
  'Most Recent Mortgage',
  'Recent Death in Family',
  'Recently Divorced',
  'Recent Mover',
  'Recently Changed Jobs',
  'Recently Promoted',
]

export const US_STATES = [
  'California',
  'Texas',
  'Florida',
  'New York',
  'Illinois',
  'Pennsylvania',
  'Ohio',
  'Georgia',
  'North Carolina',
  'Michigan',
  'Washington',
  'Colorado',
  'Arizona',
  'New Jersey',
  'Virginia',
  'Massachusetts',
]
